import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1cadafa4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cadafa4')) {
      api.createRecord('1cadafa4', component.options)
    } else {
      api.reload('1cadafa4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=1cadafa4", function () {
      api.rerender('1cadafa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/CompanySwitcher/index.vue"
export default component.exports